export default {
    data() {
        return {
            error: {
                message: '',
                variant: 'error', // Available variants: 'error' | 'warn' | 'info'
            },
        };
    },
    computed: {
        hasError() {
            return this.error.message;
        },
    },
    methods: {
        resetDataError() {
            this.error = { ...this.$options.data.call(this).error };
        },
        setMessageError(message, variant = 'error') {
            this.error.message = message || this.$t('api-error-handler.message.error');
            this.error.variant = variant;
        },
    },
};
